import { getIconFromRegistry } from '@unifyapps/icons/utils/getIconFromRegistry';
import { Box } from '@unifyapps/ui/components/Box';
import clsx from 'clsx';
import { navIconVariants } from '../styles';

export function Icon({
  icon,
  active,
  activeIcon,
}: {
  icon: string | undefined;
  active: boolean;
  activeIcon: string | undefined;
}) {
  const IconComponent = getIconFromRegistry(icon);
  const ActiveIconComponent = getIconFromRegistry(activeIcon);

  const iconClassName = navIconVariants({ active });
  const activeIconClassName = navIconVariants({ active: true });

  return (
    <>
      {IconComponent ? (
        <IconComponent
          className={clsx(iconClassName, {
            'hidden': active && ActiveIconComponent,
          })}
        />
      ) : (
        <Box className="h-4 w-4" />
      )}
      {ActiveIconComponent ? (
        <ActiveIconComponent
          className={clsx(activeIconClassName, {
            'hidden': !active,
          })}
        />
      ) : null}
    </>
  );
}
